import * as E from '../entities';
import { EstadoSimulacion, UserAuthProvider } from '../types';
import { generateCRUD } from './CRUDGenerator';

// MANTENEDORES ============================================
export const UserCRUD = generateCRUD({
  webEntity: E.UserEntity,
  title: 'Usuarios',
  allowedActions: {
    export: false,
    add: true,
    delete: true,
    edit: true,
    editCondition: (row) => row.providerName === UserAuthProvider.internal
  },
  initialState: {
    columnVisibility: {
      _id: false
    },
    columnPinning: {
      right: ['userIsActive']
    },
    grouping: ['providerName']
  }
});

export const UserTypeCRUD = generateCRUD({
  webEntity: E.UserTypeEntity,
  title: 'Tipos de Usuario',
  allowedActions: {
    export: false,
    add: false,
    delete: false,
    edit: false
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});

export const UserOccupationCRUD = generateCRUD({
  webEntity: E.UserOccupationEntity,
  title: 'Ocupaciones de Usuario',
  allowedActions: {
    export: false,
    add: true,
    delete: true,
    edit: true
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});

export const MyStudiesCRUD = generateCRUD({
  webEntity: E.MyStudiesEntity,
  title: 'Mis Estudios',
  allowedActions: {
    export: false,
    add: false,
    delete: false,
    edit: false
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});

export const OtherStudiesCRUD = generateCRUD({
  webEntity: E.OtherStudiesEntity,
  title: 'Otros Estudios',
  allowedActions: {
    export: false,
    add: false,
    delete: false,
    edit: false
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});

export const StudiesInProgressCRUD = generateCRUD({
  webEntity: E.StudiesInProgressEntity,
  title: 'En proceso',
  query: { estadoSimulacion: EstadoSimulacion.inProgress },
  allowedActions: {
    export: false,
    add: false,
    delete: false,
    edit: false
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});

export const StudiesCompletedCRUD = generateCRUD({
  webEntity: E.StudiesCompletedEntity,
  title: 'Terminados',
  query: { estadoSimulacion: EstadoSimulacion.finished },
  allowedActions: {
    export: false,
    add: false,
    delete: false,
    edit: false
  },
  initialState: {
    columnVisibility: {
      _id: false
    }
  }
});
